import React from 'react'
import { getFileSizeMB } from '../../../helpers/file/FileHelper'
import { Tooltip } from '@mui/material'

const FileBdItem = ({ file }) => {
  return (
    <div>
            <p>
                <a href={file.src} target='_blank'>
                    {file.fileName}
                </a>
            </p>
            <p>
				<Tooltip title={`ID файлу: ${file.id}`}>
					({getFileSizeMB({ size: file.size })})
				</Tooltip>
			</p>
        </div>
  )
}

export default FileBdItem